import type {
  DefaultResponseBody,
  ListResponseBody,
  Plan,
  PlanPayment,
  PurchaseCreateResult,
  UserPlan,
} from "@gerama/types";
import { nullOn, type ApiClient } from "../client";

export function createCorePlansApi(client: ApiClient) {
  return {
    list: (signal?: AbortSignal) =>
      client
        .request<ListResponseBody<Plan>>("/plans", { signal })
        .then((res) => res.data ?? { list: [], count: 0 }),

    /** The signed-in user's active subscription, if any — requires auth. */
    mine: (signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<UserPlan>>("/plans/me", { signal })
        .then((res) => res.data ?? null)
        .catch(nullOn("plan.no_active_plan")),

    /**
     * Opens a purchase + payment for a plan — real Zarinpal integration
     * (`libs/plan`'s `PurchaseCreateUsecase`). `callbackUrl` is what the
     * gateway itself redirects the browser back to once payment finishes
     * (site's own `/subscribe/callback`), not core-api's internal
     * mobile-deep-link callback route.
     */
    createPurchase: (
      planId: number,
      callbackUrl: string,
      options: { giftRecipientPhone?: string; gateway?: "ZARINPAL" | "SAMAN" } = {},
    ) =>
      client
        .request<DefaultResponseBody<PurchaseCreateResult>>("/plans/purchases", {
          method: "POST",
          body: { planId, callbackUrl, ...options },
        })
        .then((res) => res.data as PurchaseCreateResult),

    paymentDetail: (id: number, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<PlanPayment>>(`/plans/payments/${id}`, { signal })
        .then((res) => res.data as PlanPayment),
  };
}
